"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8392],{

/***/ 88392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AU": function() { return /* reexport */ Contents; },
  "CK": function() { return /* reexport */ Copy; },
  "YE": function() { return /* reexport */ Sidebar; },
  "Le": function() { return /* reexport */ Sticky; },
  "im": function() { return /* reexport */ Wrapper; },
  "ZP": function() { return /* reexport */ Section; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Section/Section.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var _ref2 =  true ? {
  name: "15bx5k",
  styles: "overflow-x:hidden"
} : 0;

var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "ep15dag5"
} : 0)("margin:0 auto;max-width:1440px;width:100%;", function (_ref3) {
  var sticky = _ref3.sticky;
  return !sticky && _ref2;
}, " ", function (_ref4) {
  var sticky = _ref4.sticky;
  return sticky &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)(Contents, "{position:relative;height:100%;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
var RemoveOverflowFromHTML =  true ? {
  name: "14k51fn",
  styles: "html{overflow-x:initial;}"
} : 0;
var Sticky = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ep15dag4"
} : 0)( true ? {
  name: "18krqsz",
  styles: "position:sticky;top:102px;left:0"
} : 0);

var _ref =  true ? {
  name: "uriyod",
  styles: "display:grid;grid-template-columns:minmax(0px, 1280px);grid-template-areas:'contents';row-gap:0"
} : 0;

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ep15dag3"
} : 0)("display:grid;row-gap:80px;padding:40px 24px;", function (_ref5) {
  var theme = _ref5.theme;
  return (
    /*#__PURE__*/

    /*#__PURE__*/
    (0,emotion_react_browser_esm/* css */.iv)(theme.breakpoints.up("sm"), "{padding:80px 40px;}", theme.breakpoints.up("lg"), "{padding:80px;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0)
  );
}, " ", function (_ref6) {
  var variant = _ref6.variant;
  return variant === "noCopy" && _ref;
}, " ", function (_ref7) {
  var theme = _ref7.theme,
      variant = _ref7.variant,
      copyVariant = _ref7.copyVariant;
  return variant === "centered" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("grid-template-rows:auto auto;grid-template-columns:100%;grid-template-areas:'copy' 'contents';justify-items:center;justify-content:center;", Copy, "{justify-items:center;text-align:center;max-width:", copyVariant === "narrow" ? "480px" : "844px", ";", copyVariant === "narrow" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)(theme.breakpoints.up("lg"), "{max-width:504px;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0), ";}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref8) {
  var theme = _ref8.theme,
      variant = _ref8.variant,
      reverse = _ref8.reverse,
      copyVariant = _ref8.copyVariant;
  return variant === "2Col" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("max-width:720px;row-gap:40px;grid-template-areas:'copy' 'contents';justify-content:center;", Contents, "{justify-items:center;display:grid;}", theme.breakpoints.up("md"), "{padding:80px 0;margin:auto;}", theme.breakpoints.up("lg"), "{max-width:100%;padding:80px;column-gap:80px;grid-template-columns:minmax(320px, 50%) minmax(410px, 50%);grid-template-areas:'copy contents';justify-content:flex-start;", Copy, "{justify-self:end;max-width:", copyVariant === "narrow" ? "392px" : "unset", ";}", reverse &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("direction:rtl;", Copy, "{direction:initial;}", Contents, "{direction:initial;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0), " ", Contents, "{display:block;min-width:480px;}}", theme.breakpoints.up("xl"), "{column-gap:120px;grid-template-columns:minmax(352px, 50%) minmax(480px, 50%);}", theme.breakpoints.up("xxl"), "{padding:", copyVariant === "narrow" ? "80px" : "80px auto", ";}", Copy, "{justify-items:start;align-content:flex-start;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref9) {
  var theme = _ref9.theme,
      variant = _ref9.variant,
      reverse = _ref9.reverse,
      sidebarSize = _ref9.sidebarSize;
  return variant === "sidebar" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("row-gap:40px;column-gap:56px;grid-template-areas:'sidebar' 'contents';", theme.breakpoints.up("sm"), "{row-gap:56px;}", theme.breakpoints.up("xl"), "{row-gap:0;grid-template-areas:'sidebar contents';grid-template-columns:", sidebarSize === "small" ? 276 : 374, "px auto;column-gap:", sidebarSize === "small" ? 160 : 80, "px;}", reverse &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("direction:rtl;", Sidebar, "{direction:initial;}", Contents, "{direction:initial;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0), ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ep15dag2"
} : 0)("grid-area:copy;display:grid;align-self:", function (_ref10) {
  var alignSelf = _ref10.alignSelf;
  return alignSelf !== null && alignSelf !== void 0 ? alignSelf : "flex-start";
}, ";" + ( true ? "" : 0));
var Contents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ep15dag1"
} : 0)("grid-area:contents;width:100%;align-self:", function (_ref11) {
  var alignSelf = _ref11.alignSelf;
  return alignSelf !== null && alignSelf !== void 0 ? alignSelf : "flex-start";
}, ";" + ( true ? "" : 0));
var Sidebar = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ep15dag0"
} : 0)( true ? {
  name: "1ajelae",
  styles: "grid-area:sidebar;width:100%"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Section/Section.tsx





var Section = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var variant = _ref.variant,
      children = _ref.children,
      copyVariant = _ref.copyVariant,
      _ref$sidebarSize = _ref.sidebarSize,
      sidebarSize = _ref$sidebarSize === void 0 ? "large" : _ref$sidebarSize,
      reverse = _ref.reverse,
      id = _ref.id,
      className = _ref.className,
      sticky = _ref.sticky,
      ariaLabel = _ref.ariaLabel;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
    sticky: sticky,
    className: className,
    id: id,
    "aria-label": ariaLabel,
    children: [sticky && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_browser_esm/* Global */.xB, {
      styles: RemoveOverflowFromHTML
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
      ref: ref,
      variant: variant,
      copyVariant: copyVariant,
      sidebarSize: sidebarSize,
      reverse: reverse,
      children: children
    })]
  });
});
/* harmony default export */ var Section_Section = ((/* unused pure expression or super */ null && (Section)));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Section/index.ts


Section.displayName = "SectionBase";
Copy.displayName = "Section.Copy";
Contents.displayName = "Section.Contents";
Sidebar.displayName = "Section.Sidebar";
Wrapper.displayName = "Section.Wrapper";
Sticky.displayName = "Section.Sticky";


/***/ })

}]);